import InputForm from '../components/InputForm'

function Generator() {
    return (
        <>
            <InputForm />
        </>
    )
}

export default Generator
